export function calculateThreeHourRange(time) {
  // Define working hours
  const workingStart = 9;
  const workingEnd = 18;

  // Parse input time
  const [hours, minutes] = time.split(":").map(Number);

  // Convert time to minutes for easier comparison
  const totalMinutes = hours * 60 + minutes;

  // If the input time is after working hours, roll back to the closest working hours
  if (totalMinutes > workingEnd * 60) {
    return "4pm - 6pm";
  }

  // Calculate the closest working hours
  let closestStart = Math.max(
    workingStart * 60,
    Math.floor((totalMinutes - 1) / 180) * 180 + 1
  );
  let closestEnd = Math.min(
    workingEnd * 60,
    Math.ceil(totalMinutes / 180) * 180
  );

  // Convert minutes back to HH:mm format
  const formatTime = (minutes) => {
    const hh = Math.floor(minutes / 60);
    const ampm = hh < 12 ? "am" : "pm";
    const formattedHour = hh % 12 || 12;
    return `${formattedHour}${ampm}`;
  };

  // Format the output
  const result = `${formatTime(closestStart)} - ${formatTime(closestEnd)}`;

  return result;
}

export function calculateFiveHourRange(date, time, openTime, closeTime) {
  
  const formatTime = (minutes) => {
    const hh = Math.floor(minutes / 60);
    const ampm = hh < 12 ? "am" : "pm";
    const formattedHour = hh % 12 || 12;
    return `${formattedHour}${ampm}`;
  };
  
  const [openHoursString, openMinutesString] = openTime.split(':');
  const [closeHoursString, closeMinutesString] = closeTime.split(':');

  
  // Define working hours
  const workingStart = parseInt(openHoursString);
  const workingEnd = parseInt(closeHoursString);

 if(time === null || time === undefined || time === "") return "";
  // Parse input time
  const [hours, minutes] = time.split(":").map(Number);
  const currentDate = new Date();

  const currentDay = currentDate.getDate();
  const day = new Date(date).getDate();
  // Convert time to minutes for easier comparison
  const totalMinutes = hours * 60 + minutes;

 
  if (day === currentDay) {
    // If the input time is less than working start, adjust to working start
    if (totalMinutes < workingStart * 60) {
      const closestStart = workingStart * 60;
      const closestEnd = workingEnd * 60;
      return `${formatTime(closestStart)} - ${formatTime(closestEnd)}`;
    } else {
      // Calculate the closest working hours
      let closestStart = totalMinutes;
      let closestEnd = workingEnd * 60;

      // Format the output
      return `${formatTime(closestStart)} - ${formatTime(closestEnd)}`;
    }
  } else {
    // If the date is not the current date, use working start and end
    if (totalMinutes < workingStart * 60) 
      {
        
        const closestStart = workingStart * 60;
        const closestEnd = workingEnd * 60;
        return `${formatTime(closestStart)} - ${formatTime(closestEnd)}`;
      }
      else{
       
        const closestStart = totalMinutes;
        const closestEnd = workingEnd * 60;
        return `${formatTime(closestStart)} - ${formatTime(closestEnd)}`;
      }
  }

  // // If the input time is after working hours, roll back to the closest working hours
  // if (totalMinutes > workingEnd * 60) {
  //   return "1pm - 6pm"; // Adjust the start time to cover the 5-hour range, end remains 6pm
  // }

  // // Calculate the closest working hours
  // let closestStart = Math.max(
  //   workingStart * 60,
  //   Math.floor((totalMinutes - 1) / 240) * 240 + 1 // Adjust the interval to 4 hours (240 minutes)
  // );
  // let closestEnd = Math.min(
  //   workingEnd * 60,
  //   closestStart + 300 // Set the end time to 5 hours after the start time
  // );

  // Convert minutes back to HH:mm format
  

  // // Format the output
  // const result = `${formatTime(closestStart)} - ${formatTime(closestEnd)}`;

  // return result;
}
